import React, { useCallback, useEffect, useState } from "react";
import "./reverseNumberSequence.scss";
import TestFooter from "../testFooter/testFooter";
import { answeredQues } from "../../helper/testHelper";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import useTimer from "../../Hooks/useTimer";
import { totalTimeOrScore } from "../../helper/scoreCounter";
import { getStudentData } from "../../helper/localStorage";
import { addTestResult } from "../../api/addTestResult";

const grade_id = JSON.parse(localStorage.getItem("gradeId"));
const { login_id } = getStudentData();

const ReverseNumberSequence = ({ question, questions, index }) => {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC, dispatchHelper } = HelperContext();

  const [wrongAttempts, setWrongAttempts] = useState(0);
  const [correctAttempts, setCorrectAttempts] = useState(0);
  const [wrongAlert, setWrongAlert] = useState([]);
  const [userInput, setUserInput] = useState([]);
  const { pause, reset, start, time } = useTimer();

  const { isNextQues } = helperC;

  const handleUserInput = (input) => {
    if (userInput.includes(input)) {
      return;
    }
    const sortedArray = [...question.que_title2].sort((a, b) => b - a);
    const currentIndex = userInput.length;
    if (input !== sortedArray[currentIndex]) {
      setWrongAlert((prev) => [...prev, input]);
      setWrongAttempts((prev) => prev + 1);
      return;
    }
    setUserInput((prev) => [...prev, input]);
    setCorrectAttempts((prev) => prev + 1);
  };

  const handleNext = useCallback(() => {
    const nextTest = questions[index + 1];
    let timeout;
    dispatchAnswer({
      type: "ADD_ANSWER",
      payload: {
        ...answeredQues(
          "reverse_number_sequence",
          {userInput: userInput.toString(), wrongAttempts, correctAttempts},
          question,
          time
        ),
        wrongAttempts,
        correctAttempts
      },
    });
    if (index < questions.length - 1) {
      reset();
      timeout = setTimeout(() => {
        start();
        dispatchHelper({
          type: "RUNNING_QUES_ID",
          payload: nextTest.id,
        });
      }, 1000); // Reduce the timeout delay to 1 second (1000 milliseconds)
    } else {
      const answerRes = [...answerC.answers];
      const { player_time, player_score } = totalTimeOrScore(
        answerRes,
        questions,
        false //is reaction test
      );
      const formatValue = {
        grade_id,
        player_id: login_id,
        res: answerRes, // Use the updated answers here
        player_image: "",
        player_time,
        player_score,
        test_id: question.test_id,
      };
      addTestResult(formatValue, dispatchHelper, dispatchAnswer);
      dispatchHelper({
        type: "RUNNING_QUES_ID",
        payload: "submitted",
      });
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [questions, index, dispatchAnswer, userInput, wrongAttempts, correctAttempts, question, time, reset, start, dispatchHelper, answerC.answers]);  

  useEffect(() => {
    let timeout;
    if (wrongAlert.length > 0) {
      timeout = setTimeout(() => {
        setWrongAlert([]);
      }, 2000);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [wrongAlert]);

  useEffect(() => {
    if (isNextQues) {
      handleNext();
      dispatchHelper({ type: "IS_NEXT_QUES", payload: false });
    }
  }, [dispatchHelper, handleNext, isNextQues]);

  useEffect(() => {
    start();
  }, []);
  return (
    <div className="rev-flex">
      <div className="test-header rev-question">{question.que_title1}</div>
      <div className="rev-buttons-container">
        {question.que_title2.map((item) => {
          return (
            <button
              className={`button ${
                userInput.includes(item) ? "selected" : ""
              } ${wrongAlert.includes(item) ? "wrong" : ""}`.trim()}
              onClick={() => handleUserInput(item)}
              disabled={userInput.includes(item)}
            >
              {item}
            </button>
          );
        })}
      </div>
      <TestFooter
        index={index}
        question={question}
        questions={questions}
        isUserInput={userInput.length === question.que_title2.length}
      />
    </div>
  );
};

export default ReverseNumberSequence;
